import { currencyLabel } from '@/helpers/currency';
import { Sparkline } from '@payaca/ambrosia';

import { currencyCodeForRegion } from '@payaca/helpers/currencyHelper';
import { AccountRegions } from '@payaca/types/accountTypes';
import { FC, useCallback, useMemo } from 'react';
import { CHART_HEIGHT, getDateLabels } from '../utils';

export interface MiniSparklineProps {
  data: number[];
  color: string;
  name?: string;
  /** Format values as currency (data should be in minor units) */
  formatAsCurrency?: boolean;
  region?: string;
}

const MiniSparkline: FC<MiniSparklineProps> = ({
  data,
  color,
  name,
  formatAsCurrency,
  region,
}) => {
  const currencyCode = currencyCodeForRegion[region as AccountRegions];

  const dayLabels = useMemo(
    () => getDateLabels(data?.length ?? 30, region),
    [data?.length, region]
  );

  const tooltipFormatter = useCallback(
    (val: number): string => {
      if (!formatAsCurrency) {
        return val.toString();
      }
      // Values are already in minor units (pence)
      return currencyLabel(val, currencyCode, false);
    },
    [formatAsCurrency, currencyCode]
  );

  if (!data || data.length < 2) {
    return null;
  }

  return (
    <div
      style={{ height: CHART_HEIGHT.MINI_SPARKLINE }}
      className="w-full max-w-44"
    >
      <Sparkline
        data={data}
        color={color}
        height={CHART_HEIGHT.MINI_SPARKLINE}
        name={name ?? 'Value'}
        xAxisLabels={dayLabels}
        tooltipFormatter={tooltipFormatter}
      />
    </div>
  );
};

export default MiniSparkline;
